import React, { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import { useRive } from "@rive-app/react-canvas";
import whatsapp from './images/social.png';
import gmail from './images/gmail.png';
import phoneicon from './images/phone-call.png';
import './styles/Contact.css';
import bg from './images/MainBG.jpg';
import Swal from 'sweetalert2';

function RiveAnimation() {
  const { RiveComponent: RivePlayer } = useRive({
    src: "/contact.riv",
    autoplay: true,
  });

  return (
    <div className='contactRiveDiv'>
      <RivePlayer />
    </div>
  );
}

const Contact = () => {
  const [Clicked, setClicked] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const whatsappRelocation = () => {
    window.location.href = 'https://api.whatsapp.com/send/?phone=%2B919872978980&text&type=phone_number&app_absent=0';
  };

  const mailRelocation = () => {
    window.location.href = 'mailto:kanwallwalia@kanwallwaliaassociates.com';
  };

  const handleClicked = () => {
    setClicked(prev => !prev);
  };

  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    email: '',
    message: '',
  });
  const [attachments, setAttachments] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const data = new FormData();
    data.append('name', name);
    data.append('contact', phone);
    data.append('email', '');
    data.append('message', message);

    for (let i = 0; i < attachments.length; i++) {
      data.append('attachments', attachments[i]);
    }

    try {
      const res = await fetch('https://law-s8zl.onrender.com/api/sendCareerMail', {
        method: 'POST',
        body: data
      });

      if (res.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Application Sent!',
          text: 'We have received your details and will get back to you soon.',
          confirmButtonColor: '#198754'
        });
        setFormData({ name: '', contact: '', email: '', message: '' });
        setAttachments([]);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: 'Something went wrong. Please try again later.',
          confirmButtonColor: '#dc3545'
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'There was a problem sending your application.',
        confirmButtonColor: '#dc3545'
      });
    }
  };

  return (
    <div className='d-flex flex-column align-items-center' style={{
      height: '100vh',
      backgroundImage: `url(${bg})`,
      margin: 0,
      padding: 0,
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      scrollBehavior: 'smooth'
    }}>
      <Header />
      <div className='d-flex flex-column' style={{ width: '90%', marginTop: '5%' }}>
        <div className='w-100 d-flex justify-content-center align-items-center'>
          <RiveAnimation />
        </div>
        <div className='p-4' style={{
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          borderRadius: '15px'
        }}>
          <div className='d-flex w-100 justify-content-around align-items-center position-relative'>
            <div className='contactIcons' onClick={whatsappRelocation}><img src={whatsapp} alt='' /></div>
            <div className='contactIcons' onClick={mailRelocation}><img src={gmail} alt='' /></div>
            <div className='contactIcons' onClick={handleClicked}><img src={phoneicon} alt='' /></div>
            {Clicked && <div className='position-absolute' style={{ right: '6%' }}>+91-9872978980</div>}
          </div>
          <hr />
          <div className='d-flex flex-wrap gap-3' style={{ color: 'white' }}>
          <div className='d-flex justify-content-between w-100 gap-4 contactSmallScreenForm'>
            <div className='d-flex flex-column'>
              Name:
              <input
                type='text'
                className='form-control'
                placeholder='Name'
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className='d-flex flex-column'>
              Phone Number:
              <input
                type='number'
                className='form-control'
                placeholder='Number'
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </div>
            <div className='d-flex flex-column w-100'>
              Message:
              <input
                type='text'
                className='form-control'
                placeholder='Message...'
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <button type='button' className='w-100' onClick={handleSubmit}>
              SEND
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
